(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('toastHelper', toastHelper);

    toastHelper.$inject = ['$mdToast'];

    /* @ngInject */
    function toastHelper($mdToast) {
        var el;
        var service = {
            show: show
        };
        el = document.getElementById('toast-container');
        return service;

        ////////////////

        function show(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .position('bottom left')
                .parent(el);

            $mdToast.show(toast);
        }
    }

})();
